import type { MaterialsFolder } from "@/lib/materials-api";

export type MaterialsPageContext = {
  kind: "enterprise" | "brand" | "brand_site";
  brandId: string | null;
  brandSiteId: string | null;
};

export type MaterialsFolderNodeKind = MaterialsFolder["binding_kind"];

export type MaterialsFolderTreeNode = {
  folder: MaterialsFolder;
  children: MaterialsFolderTreeNode[];
};

export function folderNodeKind(folder: MaterialsFolder): MaterialsFolderNodeKind {
  return folder.binding_kind;
}

export function canManageFolder(folder: MaterialsFolder): boolean {
  return folderNodeKind(folder) === "normal";
}

/**
 * 按当前工作根组树。品牌与站点页会隐藏真实系统根，
 * 将它的直接子项挂到虚拟「全部素材」下。
 */
export function buildMaterialsFolderTree(
  folders: MaterialsFolder[],
  workRootId: number | null,
): MaterialsFolderTreeNode[] {
  const childrenOf = new Map<number | null, MaterialsFolder[]>();
  for (const folder of folders) {
    const list = childrenOf.get(folder.parent_id) ?? [];
    list.push(folder);
    childrenOf.set(folder.parent_id, list);
  }
  for (const list of childrenOf.values()) {
    list.sort((a, b) => a.id - b.id);
  }

  function walk(parentId: number | null): MaterialsFolderTreeNode[] {
    return (childrenOf.get(parentId) ?? []).map((folder) => ({
      folder,
      children: walk(folder.id),
    }));
  }

  return walk(workRootId);
}

export function materialsContextCopy(context: MaterialsPageContext): {
  title: string;
  rootLabel: string;
} {
  const title = {
    enterprise: "企业素材库",
    brand: "品牌素材库",
    brand_site: "站点素材库",
  }[context.kind];

  const rootLabel = {
    enterprise: "全部素材",
    brand: "品牌素材",
    brand_site: "站点素材",
  }[context.kind];

  return { title, rootLabel };
}
